const PERMISSION_KEY= "personalize:nebula_ultra_metadata";
const PAGE_URL = {
    NEBULA_ULTRA_METADATA_PAGE: "/admin/personalize/nebula-ultra-metadata"
}

export {PERMISSION_KEY, PAGE_URL}

